module.exports = __webpack_public_path__ + "static/media/Logo 3.1848513f.png";